module.exports = __webpack_public_path__ + "img/symbol_2.6af40936.png";